import { Flex } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'

import { DocumentHtmlPreview } from '@features/invoices/elements/DocumentHtmlPreview'

import { useInvoice } from '../../contexts/invoiceContext'
import { useFetchInvoiceHtml } from '../../hooks/useFetchInvoiceHtml'
import { InvoiceStatusCornerRibbon } from './elements/InvoiceStatusCornerRibbon'
import * as Styled from './styles'

export const InvoicePreview = (): ReactElement | null => {
  const { documentType, invoiceId } = useInvoice()
  const { invoiceHtml } = useFetchInvoiceHtml(invoiceId, documentType)

  const htmlFiles = useMemo(() => (invoiceHtml ? [invoiceHtml] : []), [invoiceHtml])

  return (
    <Styled.InvoiceHtmlPreviewWrapper>
      <InvoiceStatusCornerRibbon />
      <Flex justifyContent="center">
        <DocumentHtmlPreview htmlFiles={htmlFiles} key={invoiceId} />
      </Flex>
    </Styled.InvoiceHtmlPreviewWrapper>
  )
}
